/* =========================================================================
   Mats · Barra superior  —  <mats-topbar>
   Si el header (fijo, sticky o flotante) tapa la barra, baja la barra de
   cristal lo justo con position:relative + top (sin transform, para no romper
   menús fijos del header). Al hacer scroll vuelve a su sitio a medida que la
   barra superior sale de pantalla.
   ========================================================================= */
(() => {
  if (customElements.get('mats-topbar')) return;

  const HEADER_SELECTORS = [
    '.shopify-section-group-header-group[id$="__header"]',
    '[id^="shopify-section-"][id$="__header"]',
    '.header-section',
    'header'
  ];

  class MatsTopbar extends HTMLElement {
    connectedCallback() {
      if (this.dataset.pushHeader !== 'true') return;
      this._shift = 0;
      this._update = () => {
        cancelAnimationFrame(this._raf);
        this._raf = requestAnimationFrame(() => this.nudge());
      };
      window.addEventListener('scroll', this._update, { passive: true });
      window.addEventListener('resize', this._update, { passive: true });
      window.addEventListener('load', this._update, { once: true });
      // El header puede montarse después (otra sección del grupo).
      requestAnimationFrame(() => this.nudge());
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._update);
      window.removeEventListener('resize', this._update);
      cancelAnimationFrame(this._raf);
      this.restore();
    }

    findHeader() {
      for (const sel of HEADER_SELECTORS) {
        const el = document.querySelector(sel);
        if (el && !el.contains(this) && !this.contains(el)) return el;
      }
      return null;
    }

    // La barra de cristal visible: el elemento de tamaño "barra" más bajo del header.
    findBar(header) {
      let best = header;
      let bestBottom = header.getBoundingClientRect().bottom;
      header
        .querySelectorAll('header, .header, [class*="header__wrapper"], [class*="header-glass"], [class*="header__inner"]')
        .forEach((el) => {
          const r = el.getBoundingClientRect();
          if (r.height < 30 || r.height > 220) return;
          if (best === header || r.bottom > bestBottom) {
            best = el;
            bestBottom = r.bottom;
          }
        });
      return best;
    }

    nudge() {
      const header = this.findHeader();
      if (!header) return;

      if (!this._bar || !header.contains(this._bar) && this._bar !== header) {
        this.restore();
        this._bar = this.findBar(header);
        const cs = getComputedStyle(this._bar);
        this._saved = { position: this._bar.style.position, top: this._bar.style.top };
        this._baseTop = cs.position === 'static' ? 0 : (parseFloat(cs.top) || 0);
        this._static = cs.position === 'static';
        this._shift = 0;
      }

      const naturalTop = this._bar.getBoundingClientRect().top - this._shift;
      const shift = Math.max(0, Math.round(this.getBoundingClientRect().bottom - naturalTop));
      if (shift === this._shift) return;

      this._shift = shift;
      if (shift) {
        if (this._static) this._bar.style.position = 'relative';
        this._bar.style.top = `${this._baseTop + shift}px`;
      } else {
        this._bar.style.position = this._saved.position;
        this._bar.style.top = this._saved.top;
      }
    }

    restore() {
      if (!this._bar || !this._saved) return;
      this._bar.style.position = this._saved.position;
      this._bar.style.top = this._saved.top;
      this._bar = null;
      this._shift = 0;
    }
  }

  customElements.define('mats-topbar', MatsTopbar);
})();
